import * as React from 'react'
import { getDriversInGroupDetailsColumns } from '@/modules/drivers/constants/tables'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'
import { useSortableData } from '@/modules/drivers/hooks/useSortTable'
import { TableHeader } from '@/modules/drivers/shared/tableItems/TableHeader'
import { DriverModel } from '@/app/models'
import { useEditGroups } from '@/modules/drivers/context/EditGroupsContext'
import { LoaderIcon } from '@/app/features/icons/Loader'
import { DriverInGroupRow } from './DriverInGroupRow'

const DriversInGroupTable = ({ allDrivers }: { allDrivers: DriverModel[] }) => {
  const { t } = useLocalize()
  const columns = getDriversInGroupDetailsColumns(t)
  const { isSelectedAny, selectedGroup, toggleAll, toggleId, loading } =
    useEditGroups()

  const { sortedData, sortConfig, handleHeaderClick } = useSortableData({
    data: allDrivers,
    tableColumns: columns,
    includeActiveSorting: false,
  })

  return (
    <div
      className={`tw-relative tw-overflow-x-auto tw-border tw-border-x-base-300 tw-border-t-base-300 ${
        isSelectedAny && 'tw-rounded-t-none'
      }`}
    >
      {loading && (
        <div className="tw-absolute tw-inset-0 tw-z-50 tw-grid tw-place-items-center tw-bg-black/10">
          <LoaderIcon className="tw-animate-spin" />
        </div>
      )}
      <table className="tw-w tw-w-full tw-table-auto tw-border-collapse tw-pt-2">
        <TableHeader
          opacity
          toggleAll={toggleAll}
          isSelectedAny={isSelectedAny}
          columns={columns}
          sortConfig={sortConfig}
          onHeaderClick={handleHeaderClick}
        />

        <tbody>
          {sortedData.map((item) => (
            <DriverInGroupRow
              key={item.id}
              driver={item}
              selectedIds={selectedGroup.map((g) => g)}
              toggleId={toggleId}
            />
          ))}
        </tbody>
      </table>
    </div>
  )
}

export default DriversInGroupTable
